import { Base } from "ui/Scripts/source/framework/base";
import { IUnitPermissionUserGroup } from "../userGroup/unitPermissionUserGroup";
import { UnitNode } from "./unitNode";
import { IUnitSummaryUserGroup, UnitSummaryUserGroup } from "./unitSummaryUserGroup";

export interface IUnitSummaryNode {
    id: string;
    name: string;
    userGroups: IUnitSummaryUserGroup[];
    children: IUnitSummaryNode[];

    setUserGroupPermissions(permissionUserGroup: IUnitPermissionUserGroup, permissionUnitNode: UnitNode);
}

export class UnitSummaryNode implements IUnitSummaryNode {
    id: string;
    name: string;
    userGroups: UnitSummaryUserGroup[];
    children: UnitSummaryNode[];

    constructor();
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.name = obj && obj.name || "";
        this.userGroups = Base.getTypedArray(obj ? obj.userGroups : null, UnitSummaryUserGroup);
        this.children = Base.getTypedArray(obj ? obj.children : null, UnitSummaryNode);
    }

    setUserGroupPermissions(permissionUserGroup: IUnitPermissionUserGroup, permissionUnitNode: UnitNode) {
        const userGroup = new UnitSummaryUserGroup();
        userGroup.name = permissionUserGroup.name;
        userGroup.type = permissionUserGroup.type;
        userGroup.permission = permissionUnitNode.permission;
        this.userGroups.push(userGroup);
        for (let i = 0; i < this.children.length; i++) {
            this.children[i].setUserGroupPermissions(permissionUserGroup, permissionUnitNode.children[i]);
        }
    }
}